import Vue from "vue";
import VueRouter from "vue-router";
import i18n from "@helpers/i18n.js";
import crypto from "../utils/crypto";

import Settings from "../settings.json";

function isEmployeeSessionValid() {
  try {
    const eatRaw = localStorage.getItem("employee_eat");
    if (!eatRaw) return false;
    const eat = Number(crypto.decrypto(eatRaw));
    if (Number.isNaN(eat) || eat < Date.now()) return false;
    const userRaw = localStorage.getItem("employee_user");
    if (!userRaw) return false;
    const user = JSON.parse(crypto.decrypto(userRaw));
    return !!(user && user.data && user.data.token);
  } catch {
    return false;
  }
}

Vue.use(VueRouter);

// services
// import AutoLogin from "./services/AutoLogin";

const routes = [
  {
    name: "app-start",
    path: "/",
    redirect: "/",
    component: () =>
      import(/* webpackChunkName: "app-start" */ "../layouts/default.vue"),
    children: [
      {
        name: "home",
        path: "",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(/* webpackChunkName: "home" */ "../views/Home.vue"),
      },
      {
        name: "employees",
        path: "employees",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(/* webpackChunkName: "employees" */ "../views/Employees.vue"),
      },
      {
        name: "employee-devices",
        path: "employees/devices",
        meta: {
          layout: "default",
          auth: true,
          breadcrumbs: [
            { name: "app-start", path: { name: "app-start" } },
            { name: "employees", path: { name: "employees" } },
            {
              name: "employee-devices",
              path: { name: "employee-devices" },
            },
          ],
        },
        component: () =>
          import(
            /* webpackChunkName: "employee-devices" */ "../views/EmployeeDevices.vue"
          ),
      },
      {
        name: "employees_detail",
        path: "employees/:id",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "employees" */ "../views/EmployeeDetail.vue"
          ),
      },
      {
        name: "companies",
        path: "companies",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(/* webpackChunkName: "companies" */ "../views/Companies.vue"),
      },
      {
        name: "customers",
        path: "customers",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(/* webpackChunkName: "customers" */ "../views/Customers.vue"),
      },
      {
        name: "customers_settings",
        path: "customers/settings",
        breadcrumbs: [
          { name: "app-start", path: { name: "app-start" } },
          { name: "customers", path: { name: "customers" } },
          { name: "customers_settings", path: { name: "customers_settings" } },
        ],
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "customers-settings" */ "../views/CustomersSettings.vue"
          ),
      },
      {
        name: "customers_detail",
        path: "customers/:id",
        breadcrumbs: [
          { name: "app-start", path: { name: "app-start" } },
          { name: "customers", path: { name: "customers" } },
          { name: "customers_detil", path: { name: "customes_detail" } },
        ],
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "CustomerDetail" */ "../views/CustomerDetail.vue"
          ),
      },
      {
        name: "plans",
        path: "plans",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(/* webpackChunkName: "plans" */ "../views/Plans.vue"),
      },
      {
        name: "plan-monitoring",
        path: "plan-monitoring",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "plan-monitoring" */ "../views/PlanMonitoring.vue"
          ),
      },
      {
        name: "live-tracking",
        path: "live-tracking",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "live-tracking" */ "../views/LiveTracking.vue"
          ),
      },
      {
        name: "products",
        path: "products",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(/* webpackChunkName: "products" */ "../views/Products.vue"),
      },
      {
        name: "product-detail",
        path: "products/:id",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "product-detail" */ "../views/ProductDetail.vue"
          ),
      },
      {
        name: "product-category-detail",
        path: "product-categories/:id",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "product-category-detail" */ "../views/ProductCategoryDetail.vue"
          ),
      },
      {
        name: "productCategories",
        path: "product-categories",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "productCategories" */ "../views/ProductCategories.vue"
          ),
      },
      {
        name: "product-brands",
        path: "product-brands",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "product-brands" */ "../views/ProductBrands.vue"
          ),
      },
      {
        name: "extraProductRules",
        path: "extra-product-rules",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "extraProductRules" */ "../views/ExtraProductRules.vue"
          ),
      },
      {
        name: "extraProducts",
        path: "extra-product-rules/:id",

        meta: {
          layout: "default",
          auth: true,
          breadcrumbs: [
            { name: "app-start", path: { name: "app-start" } },
            { name: "extraProductRules", path: { name: "extraProductRules" } },
            { name: "extraProducts", path: { name: "extraProducts" } },
          ],
        },
        component: () =>
          import(
            /* webpackChunkName: "extraProductRules" */ "../views/ExtraProducts.vue"
          ),
      },
      {
        name: "paymentSettings",
        path: "payment-settings",

        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "paymentSettings" */ "../views/PaymentSettings.vue"
          ),
      },
      {
        name: "paymentMethods",
        path: "payment-settings/:id",

        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "paymentMethods" */ "../views/PaymentMethods.vue"
          ),
      },
      {
        name: "discounts",
        path: "payment-methods/:id",

        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(/* webpackChunkName: "discounts" */ "../views/Discounts.vue"),
      },
      {
        name: "payment-term-rules",
        path: "payment-methods/:paymentMethodId/payment-term-rules",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "payment-term-rules" */ "../views/PaymentTermRules.vue"
          ),
      },
      {
        name: "credit-cards",
        path: "credit-cards",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "credit-cards" */ "../views/CreditCards.vue"
          ),
      },
      {
        name: "credit-card-detail",
        path: "credit-cards/:id",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "credit-card-detail" */ "../views/CreditCardDetail.vue"
          ),
      },
      {
        name: "sales",
        path: "sales",

        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(/* webpackChunkName: "sales" */ "../views/Sales.vue"),
      },
      {
        name: "e-invoices",
        path: "e-invoices",

        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(/* webpackChunkName: "e-invoices" */ "../views/EInvoices.vue"),
      },
      {
        name: "e-invoice-detail",
        path: "e-invoices/:saleId",

        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "e-invoice-detail" */ "../views/EInvoiceDetail.vue"
          ),
      },
      {
        name: "e-invoice-document-detail",
        path: "e-invoices/:saleId/:invoiceId",

        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "e-invoice-document-detail" */ "../views/EInvoiceDocumentDetail.vue"
          ),
      },
      {
        name: "debtors",
        path: "debtors",
        breadcrumbs: [
          { name: "app-start", path: { name: "app-start" } },
          { name: "debtors", path: { name: "debtors" } },
        ],
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(/* webpackChunkName: "debtors" */ "../views/Debtors.vue"),
      },
      {
        name: "sale-detail",
        path: "sales/:id",

        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "sale-detail" */ "../views/SaleDetail.vue"
          ),
      },
      {
        name: "transaction-detail",
        path: "transaction/:id",
        breadcrumbs: [
          { name: "app-start", path: { name: "app-start" } },
          { name: "transactions", path: { name: "transactions" } },
          { name: "transaction-detail", path: { name: "transaction-detail" } },
        ],
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "transaction-detail" */ "../views/TransactionDetail.vue"
          ),
      },
      {
        name: "transactions",
        path: "transactions",
        breadcrumbs: [
          { name: "app-start", path: { name: "app-start" } },
          { name: "transactions", path: { name: "transactions" } },
        ],
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "transactions" */ "../views/Transactions.vue"
          ),
      },
      {
        name: "transaction-report-list",
        path: "transaction-report-list",
        breadcrumbs: [
          { name: "app-start", path: { name: "app-start" } },
          {
            name: "transaction-report-list",
            path: { name: "transaction-report-list" },
          },
        ],
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "transaction-report-list" */ "../views/TransactionReportList.vue"
          ),
      },
      {
        name: "sale-update-checkout",
        path: "sales/:id/update-checkout",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "sale-update-checkout" */ "../views/SaleUpdateCheckout.vue"
          ),
      },
      {
        name: "regions",
        path: "regions",

        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(/* webpackChunkName: "Regions" */ "../views/Regions.vue"),
      },
      {
        name: "regions-detail",
        path: "regions/:id",

        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "Regions-detail" */ "../views/RegionDetail.vue"
          ),
      },
      {
        name: "special-discounts",
        path: "special-discounts",

        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "special-discounts" */ "../views/SpecialDiscounts.vue"
          ),
      },
      {
        name: "bank-accounts",
        path: "bank-accounts",

        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "bank-accounts" */ "../views/BankAccounts.vue"
          ),
      },
      {
        name: "admins",
        path: "admins",

        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(/* webpackChunkName: "admins" */ "../views/Admins.vue"),
      },
      {
        name: "tags",
        path: "tags",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(/* webpackChunkName: "tags" */ "../views/Tags.vue"),
      },
      {
        name: "tag-rules",
        path: "tags/:tagId/rules",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(/* webpackChunkName: "tag-rules" */ "../views/TagRules.vue"),
      },
      {
        name: "leads",
        path: "leads",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(/* webpackChunkName: "leads" */ "../views/Leads.vue"),
      },
      {
        name: "lead-dashboard",
        path: "lead/dashboard",
        meta: { layout: "default", auth: true },
        component: () =>
          import(
            /* webpackChunkName: "lead-dashboard" */ "../views/LeadDashboard.vue"
          ),
      },
      {
        name: "lead-settings",
        path: "leads/settings",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "lead-settings" */ "../views/LeadSettings.vue"
          ),
      },
      {
        name: "lead-report-center",
        path: "lead/report-center",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "lead-report-center" */ "../views/LeadReportCenter.vue"
          ),
      },
      {
        name: "lead-performance-report",
        path: "lead/performance-report",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "lead-performance-report" */ "../views/LeadPerformanceReport.vue"
          ),
      },
      {
        name: "lead-sales-report",
        path: "lead/sales-report",
        meta: { layout: "default", auth: true },
        component: () =>
          import(
            /* webpackChunkName: "lead-sales-report" */ "../views/LeadSalesReport.vue"
          ),
      },
      {
        name: "brand-sales-report",
        path: "lead/brand-sales-report",
        meta: { layout: "default", auth: true },
        component: () =>
          import(
            /* webpackChunkName: "brand-sales-report" */ "../views/BrandSalesReport.vue"
          ),
      },
      {
        name: "lead-sales-report-details",
        path: "lead/sales-report/details",
        meta: { layout: "default", auth: true },
        component: () =>
          import(
            /* webpackChunkName: "lead-sales-report-details" */ "../views/LeadSalesReportDetails.vue"
          ),
      },
      {
        name: "lead-tag-report",
        path: "lead/tag-report",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "lead-tag-report" */ "../views/LeadTagReport.vue"
          ),
      },
      {
        name: "lead-report-details",
        path: "lead/report-details",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "lead-report-details" */ "../views/LeadAdvertisementReportDetails.vue"
          ),
      },
      {
        name: "lead-tag-activity",
        path: "lead-tag-activity",
        meta: { layout: "default", auth: true },
        component: () => import("../views/LeadTagActivity.vue"),
      },
      {
        name: "lead-tag-time-lines",
        path: "lead-tag-time-lines",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "lead-tag-time-lines" */ "../views/LeadTagTimeLines.vue"
          ),
      },
      {
        name: "lead-detail",
        path: "leads/:id",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "lead-detail" */ "../views/LeadDetail.vue"
          ),
      },
      {
        name: "main-platforms",
        path: "main-platforms",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "main-platforms" */ "../views/MainPlatforms.vue"
          ),
      },
      {
        name: "lead-platforms",
        path: "lead-platforms",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "lead-platforms" */ "../views/LeadPlatforms.vue"
          ),
      },
      {
        name: "lead-campaigns",
        path: "lead-campaigns",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "lead-campaigns" */ "../views/LeadCampaigns.vue"
          ),
      },
      {
        name: "lead-campaigns-detail",
        path: "lead-campaigns/:id",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "lead-campaigns-detail" */ "../views/LeadCampaignDetail.vue"
          ),
      },
      {
        name: "lead-advertisements",
        path: "lead-advertisements",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "lead-advertisements" */ "../views/LeadAdvertisements.vue"
          ),
      },
      {
        path: "lead-advertisements/create",
        redirect: { name: "lead-advertisements" },
      },
      {
        name: "lead-advertisements-report-details",
        path: "lead-advertisements/:id/report-details",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "lead-advertisements-report-details" */ "../views/LeadAdvertisementReportDetails.vue"
          ),
      },
      {
        name: "lead-advertisements-detail",
        path: "lead-advertisements/:id",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "lead-advertisements-detail" */ "../views/LeadAdvertisementDetail.vue"
          ),
      },
      {
        name: "workspaces",
        path: "workspaces",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "workspaces" */ "../views/Workspaces.vue"
          ),
      },
      {
        name: "lead-import",
        path: "lead-import",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "lead-import" */ "../views/LeadImport.vue"
          ),
      },
      {
        name: "lead-import-history",
        path: "lead-import-history",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "lead-import-history" */ "../views/LeadImportHistory.vue"
          ),
      },
      {
        name: "bot-integrations",
        path: "bot-integrations",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "bot-integrations" */ "../views/BotIntegrations.vue"
          ),
      },
      {
        name: "lead-integrations",
        path: "lead-integrations",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "lead-integrations" */ "../views/LeadIntegrations.vue"
          ),
      },
      {
        name: "lead-integrations-heoxify",
        path: "lead-integrations/heoxify",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "lead-integrations-heoxify" */ "../views/LeadIntegrationsHeoxify.vue"
          ),
      },
      {
        name: "notes",
        path: "notes",

        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(/* webpackChunkName: "notes" */ "../views/Notes.vue"),
      },
      {
        name: "sale-notes",
        path: "sale-notes",

        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(/* webpackChunkName: "saleNotes" */ "../views/SaleNotes.vue"),
      },
      {
        name: "meeting-results",
        path: "meeting-results",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "meetingResults" */ "../views/MeetingResults.vue"
          ),
      },
      {
        name: "sale-statuses",
        path: "sale-statuses",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "saleStatuses" */ "../views/SaleStatuses.vue"
          ),
      },
      {
        name: "active-meetings",
        path: "active-meetings",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "activeMeetings" */ "../views/ActiveMeetings.vue"
          ),
      },
      {
        name: "completed-meetings",
        path: "completed-meetings",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "completedMeetings" */ "../views/CompletedMeetings.vue"
          ),
      },
      {
        name: "plans-detail",
        path: "plans/:id",

        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "plans-detail" */ "../views/PlanDetail.vue"
          ),
      },
      {
        name: "create-customer-report",
        path: "create-customer-report/:planId",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "create-customer-report" */ "../views/CreateCustomerReport.vue"
          ),
      },
      {
        name: "sale-statistics",
        path: "statistics/sale-statistics",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "sale-statistics" */ "../views/statistics/SaleStatistics.vue"
          ),
      },
      {
        path: "insights",
        component: () =>
          import(
            /* webpackChunkName: "statistics-insights" */ "../views/statisticsNewDesign/Shell.vue"
          ),
        meta: {
          layout: "default",
          auth: true,
        },
        children: [
          {
            name: "statistics-hub",
            path: "",
            meta: { layout: "default", auth: true },
            component: () =>
              import(
                /* webpackChunkName: "statistics-insights-hub" */ "../views/statisticsNewDesign/Hub.vue"
              ),
          },
          {
            name: "overview-executive",
            path: "overview",
            meta: { layout: "default", auth: true },
            component: () =>
              import(
                /* webpackChunkName: "statistics-insights-overview" */ "../views/statisticsNewDesign/OverviewExecutive.vue"
              ),
          },
          {
            name: "reps-performance",
            path: "reps",
            meta: { layout: "default", auth: true },
            component: () =>
              import(
                /* webpackChunkName: "statistics-insights-reps" */ "../views/statisticsNewDesign/RepsPerformance.vue"
              ),
          },
          {
            name: "products-mix",
            path: "products",
            meta: { layout: "default", auth: true },
            component: () =>
              import(
                /* webpackChunkName: "statistics-insights-products" */ "../views/statisticsNewDesign/ProductsMix.vue"
              ),
          },
          {
            name: "geo-regions-locations",
            path: "geo",
            meta: { layout: "default", auth: true },
            component: () =>
              import(
                /* webpackChunkName: "statistics-insights-geo" */ "../views/statisticsNewDesign/GeoRegionsLocations.vue"
              ),
          },
          {
            name: "customers-segments",
            path: "customers",
            meta: { layout: "default", auth: true },
            component: () =>
              import(
                /* webpackChunkName: "statistics-insights-customers" */ "../views/statisticsNewDesign/CustomersSegments.vue"
              ),
          },
          {
            name: "collections-risk",
            path: "collections",
            meta: { layout: "default", auth: true },
            component: () =>
              import(
                /* webpackChunkName: "statistics-insights-collections" */ "../views/statisticsNewDesign/CollectionsRisk.vue"
              ),
          },
          {
            name: "profitability",
            path: "profit",
            meta: { layout: "default", auth: true },
            component: () =>
              import(
                /* webpackChunkName: "statistics-insights-profit" */ "../views/statisticsNewDesign/Profitability.vue"
              ),
          },
        ],
      },
      {
        name: "employee-statistics",
        path: "statistics/employee-statistics",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "employee-statistics" */ "../views/statistics/EmployeeStatistics.vue"
          ),
      },
      {
        name: "employee-statistics-list",
        path: "statistics/employee-statistics/list",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "employee-statistics-list" */ "../views/statistics/EmployeeStatisticsList.vue"
          ),
      },
      {
        name: "employee-product-profit-statistics",
        path: "reports/employee-product-profit-statistics",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "employee-product-profit-statistics" */ "../views/reports/EmployeeProductProfitStatistics.vue"
          ),
      },

      {
        name: "product-statistics",
        path: "statistics/product-statistics",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "product-statistics" */ "../views/statistics/ProductStatistics.vue"
          ),
      },
      {
        name: "products-statistics-list",
        path: "statistics/products-statistics/list",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "products-statistics-list" */ "../views/statistics/ProductsStatisticsList.vue"
          ),
      },
      {
        name: "customer-statistics",
        path: "statistics/customer-statistics",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "customer-statistics" */ "../views/statistics/CustomerStatistics.vue"
          ),
      },
      {
        name: "customer-statistics-list",
        path: "statistics/customer-statistics/list",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "customer-statistics-list" */ "../views/statistics/CustomerStatisticsList.vue"
          ),
      },
      {
        name: "region-statistics",
        path: "statistics/region-statistics",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "region-statistics" */ "../views/statistics/RegionStatistics.vue"
          ),
      },
      {
        name: "region-statistics-list",
        path: "statistics/region-statistics/list",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "region-statistics-list" */ "../views/statistics/RegionStatisticsList.vue"
          ),
      },
      {
        name: "product-category-statistics",
        path: "statistics/product-category-statistics",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "product-category-statistics" */ "../views/statistics/ProductCategoryStatistics.vue"
          ),
      },
      {
        name: "product-category-statistics-list",
        path: "statistics/product-category-statistics/list",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "product-category-statistics-list" */ "../views/statistics/ProductCategoriesStatisticsList.vue"
          ),
      },
      {
        name: "product-category-statistics-details",
        path: "statistics/product-category-statistics/:id",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "product-category-statistics-details" */ "../views/statistics/Details/ProductCategoryStatistics.vue"
          ),
      },
      {
        name: "product-statistics-details",
        path: "statistics/product-statistics/:id",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "product-statistics-details" */ "../views/statistics/Details/ProductStatistics.vue"
          ),
      },
      {
        name: "region-statistics-details",
        path: "statistics/region-statistics/:id",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "region-statistics-details" */ "../views/statistics/Details/RegionStatistics.vue"
          ),
      },
      {
        name: "customer-statistics-details",
        path: "statistics/customer-statistics/:id",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "customer-statistics-details" */ "../views/statistics/Details/CustomerStatistics.vue"
          ),
      },
      {
        name: "employee-statistics-details",
        path: "statistics/employee-statistics/:id",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "employee-statistics-details" */ "../views/statistics/Details/EmployeeStatistics.vue"
          ),
      },
      {
        name: "location-statistics",
        path: "statistics/location-statistics",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "location-statistics" */ "../views/statistics/LocationStatistics.vue"
          ),
      },
      {
        name: "location-statistics-list",
        path: "statistics/location-statistics/list",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "location-statistics-list" */ "../views/statistics/LocationStatisticsList.vue"
          ),
      },
      {
        name: "location-statistics-details",
        path: "statistics/location-statistics/:id",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "location-statistics-details" */ "../views/statistics/Details/LocationStatistics.vue"
          ),
      },
      {
        name: "statistics-map-view",
        path: "statistics/map-view",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "statistics-map-view" */ "../views/statistics/StatisticMapView.vue"
          ),
      },
      {
        name: "sale-target",
        path: "sale-target",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "sale-target" */ "../views/SaleTarget.vue"
          ),
      },
      {
        name: "sale-target-by-region-id",
        path: "sale-target/region/:regionId",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "sale-target-by-region-id" */ "../views/SaleTargetByRegionId.vue"
          ),
      },
      {
        name: "customer-reports",
        path: "customer-reports",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "customer-reports" */ "../views/CustomerReports.vue"
          ),
      },
      {
        name: "customer-report-detail",
        path: "customer-report/:id",
        meta: {
          auth: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "customer-report-detail" */ "../views/CustomerReportsDetail.vue"
          ),
      },
      {
        name: "customer-report-response",
        path: "customer-report-response/:id",
        meta: {
          auth: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "customer-report-response" */ "../views/CustomerReportResponse.vue"
          ),
      },
      {
        name: "get-employee-bonus-by-region-id",
        path: "get-employee-bonus/:regionId",
        meta: {
          auth: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "get-employee-bonus" */ "../views/GetEmployeeBonus.vue"
          ),
      },
      {
        name: "employee-bonus-list",
        path: "employee-bonus-list",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "employee-bonus-list" */ "../views/EmployeeBonusList.vue"
          ),
      },
      {
        name: "integrations",
        path: "integrations",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () => import("../views/Integrations.vue"),
      },
      {
        name: "invoice-integration",
        path: "integrations/invoice",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "invoice-integration" */ "../views/InvoiceIntegration.vue"
          ),
      },
      {
        name: "integrations-parasut-customers",
        path: "integrations/parasut/customers",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () => import("../views/integrations/parasut/customer.vue"),
      },
      {
        name: "integrations-parasut-regions",
        path: "integrations/parasut/regions",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () => import("../views/integrations/parasut/Regions.vue"),
      },
      {
        name: "integrations-parasut-employees",
        path: "integrations/parasut/employees",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () => import("../views/integrations/parasut/Employees.vue"),
      },
      {
        name: "integrations-parasut-product-categories",
        path: "integrations/parasut/product-categories",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import("../views/integrations/parasut/ProductCategories.vue"),
      },
      {
        name: "integrations-parasut-products",
        path: "integrations/parasut/products",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () => import("../views/integrations/parasut/Products.vue"),
      },
      {
        name: "integrations-mikro-customers",
        path: "integrations/mikro/customers",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () => import("../views/integrations/mikro/Customer.vue"),
      },
      {
        name: "integrations-mikro-accounts",
        path: "integrations/mikro/accounts",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () => import("../views/integrations/mikro/Accounts.vue"),
      },
      {
        name: "update-targets-of-employee",
        path: "update-targets-of-employee",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () => import("../views/UpdateTargetsOfEmployee.vue"),
      },
      {
        name: "checkouts",
        path: "checkouts",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () => import("../views/Checkouts.vue"),
      },
      {
        name: "mobile-app-events",
        path: "mobile-app/events",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () => import("../views/MobileApp/Event.vue"),
      },
      {
        name: "mobile-app-events-create",
        path: "mobile-app/events/create/:type",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () => import("../views/MobileApp/Event/Create.vue"),
      },
      {
        name: "mobile-app-events-edit",
        path: "mobile-app/events/:id/edit",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () => import("../views/MobileApp/Event/_id/edit.vue"),
      },
      {
        name: "mobile-app-events-detail",
        path: "mobile-app/events/:id",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () => import("../views/MobileApp/Event/_id/index.vue"),
      },
      {
        name: "mobile-app-events-detail-create-notifications",
        path: "mobile-app/events/:id/create-notifications",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import("../views/MobileApp/Event/_id/create-notifications.vue"),
      },
      {
        name: "mobile-app-deep-links",
        path: "mobile-app/deep-links",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () => import("../views/MobileApp/DeepLinks/index.vue"),
      },
      {
        name: "mobile-app-topics",
        path: "mobile-app/topics/:page",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () => import("../views/MobileApp/Topics/_page.vue"),
      },
      {
        name: "mobile-app-topics-edit",
        path: "mobile-app/topics/:page/:id",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () => import("../views/MobileApp/Topics/_page/edit.vue"),
      },
      {
        name: "mobile-app-customer-users",
        path: "mobile-app/customer-users",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () => import("../views/MobileApp/CustomerUsers/index.vue"),
      },
      {
        name: "mobile-app-money-points",
        path: "mobile-app/money-points",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () => import("../views/MobileApp/MoneyPoint/index.vue"),
      },
      {
        name: "mobile-app-topics-create",
        path: "mobile-app/topics/:page/create",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () => import("../views/MobileApp/Topics/_page/create.vue"),
      },
      {
        name: "special-product-for-target",
        path: "special-product-for-target",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "special-product-for-target" */ "../views/SpecialProductForTarget.vue"
          ),
      },
      {
        name: "settings-download",
        path: "settings",
        meta: {
          layout: "default",
          auth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "settings-download" */ "../views/Setting.vue"
          ),
      },
      {
        name: "settings-manager",
        path: "settings/manager",
        meta: {
          layout: "default",
          auth: true,
          breadcrumbs: [
            { name: "app-start", path: { name: "app-start" } },
            { name: "settings-manager", path: { name: "settings-manager" } },
          ],
        },
        component: () =>
          import(
            /* webpackChunkName: "settings-manager" */ "../views/Manager.vue"
          ),
      },
      {
        name: "subscription-management",
        path: "settings/subscription",
        meta: {
          layout: "default",
          auth: true,
          breadcrumbs: [
            { name: "app-start", path: { name: "app-start" } },
            {
              name: "subscription-management",
              path: { name: "subscription-management" },
            },
          ],
        },
        component: () =>
          import(
            /* webpackChunkName: "subscription-management" */ "../components/Subscription/Management.vue"
          ),
      },
      {
        name: "help-center",
        path: "help-center",
        meta: {
          layout: "default",
          auth: true,
          breadcrumbs: [
            { name: "app-start", path: { name: "app-start" } },
            { name: "help-center", path: { name: "help-center" } },
          ],
        },
        component: () =>
          import(
            /* webpackChunkName: "help-center" */ "../views/HelpCenter.vue"
          ),
      },
      {
        name: "help-center-article",
        path: "help-center/:slug",
        meta: {
          layout: "default",
          auth: true,
          breadcrumbs: [
            { name: "app-start", path: { name: "app-start" } },
            { name: "help-center", path: { name: "help-center" } },
            {
              name: "help-center-article",
              path: { name: "help-center-article" },
            },
          ],
        },
        component: () =>
          import(
            /* webpackChunkName: "help-center" */ "../views/HelpCenter.vue"
          ),
      },
      {
        name: "update-notes",
        path: "update-notes",
        meta: {
          layout: "default",
          auth: true,
          breadcrumbs: [
            { name: "app-start", path: { name: "app-start" } },
            { name: "update-notes", path: { name: "update-notes" } },
          ],
        },
        component: () =>
          import(
            /* webpackChunkName: "update-notes" */ "../views/UpdateNotes.vue"
          ),
      },
      {
        name: "order-management-system",
        path: "/order-management-system/:planId",
        meta: {
          auth: true,
          layout: "standalone",
        },
        component: () =>
          import(
            /* webpackChunkName: "order-management-system" */ "../views/OrderManagementSystem.vue"
          ),
      },
      {
        name: "order-management-system-update",
        path: "/order-management-system/:planId/update/:saleId",
        meta: {
          auth: true,
          layout: "standalone",
        },
        component: () =>
          import(
            /* webpackChunkName: "order-management-system-update" */ "../views/OrderManagementSystem.vue"
          ),
      },
    ],
  },
  {
    name: "employee-app-account",
    path: "/app/login",
    component: () =>
      import(
        /* webpackChunkName: "employee-app-account" */ "../layouts/employeeAccount.vue"
      ),
    children: [
      {
        name: "employee-app-login",
        path: "",
        meta: {
          layout: "employee-account",
          employeeGuest: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "employee-app-login" */ "../views/EmployeeApp/Login.vue"
          ),
      },
    ],
  },
  {
    name: "employee-app",
    path: "/app",
    redirect: { name: "employee-app-home" },
    component: () =>
      import(
        /* webpackChunkName: "employee-app" */ "../layouts/employeeApp.vue"
      ),
    children: [
      {
        name: "employee-app-home",
        path: "",
        meta: {
          layout: "employee-app",
          employeeAuth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "employee-app-home" */ "../views/EmployeeApp/Home.vue"
          ),
      },
      {
        name: "employee-app-customers",
        path: "customers",
        meta: {
          layout: "employee-app",
          employeeAuth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "employee-app-customers" */ "../views/EmployeeApp/Customers.vue"
          ),
      },
      {
        name: "employee-app-plan-detail",
        path: "plan/:id",
        meta: {
          layout: "employee-app",
          employeeAuth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "employee-app-plan-detail" */ "../views/EmployeeApp/PlanDetail.vue"
          ),
      },
      {
        name: "employee-app-create-customer-report",
        path: "create-customer-report/:planId",
        meta: {
          layout: "employee-app",
          employeeAuth: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "employee-app-create-customer-report" */ "../views/EmployeeApp/CreateCustomerReport.vue"
          ),
      },
    ],
  },
  {
    name: "account-start",
    path: "/account/",
    redirect: "/account/sign-in",
    component: () =>
      import(/* webpackChunkName: "account-start" */ "../layouts/account.vue"),
    children: [
      {
        name: "sign-in",
        path: "sign-in",
        meta: {
          layout: "account",
          auth: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "account-sign-in" */ "../views/account/SignIn.vue"
          ),
      },
      {
        name: "forget-password",
        path: "/forget-password",
        meta: {
          layout: "account",
          auth: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "account-forget-password" */ "../views/ForgetPassword.vue"
          ),
      },
      {
        name: "reset-password",
        path: "/reset-password",
        meta: {
          layout: "account",
          auth: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "account-reset-password" */ "../views/ResetPassword.vue"
          ),
      },
      {
        name: "employee-register",
        path: "/employee-register",
        meta: {
          layout: "account",
          auth: false,
        },
        component: () =>
          import(
            /* webpackChunkName: "account-employee-register" */ "../views/EmployeeRegister.vue"
          ),
      },
    ],
  },
  {
    name: "invoice",
    path: "/invoice/:id",

    meta: {
      auth: false,
    },
    component: () =>
      import(/* webpackChunkName: "invoice" */ "../views/Invoice.vue"),
  },
  {
    name: "way-bill",
    path: "/way-bill/:id",

    meta: {
      auth: false,
    },
    component: () =>
      import(/* webpackChunkName: "way-bill" */ "../views/Waybill.vue"),
  },
  {
    name: "customer-report-response-print",
    path: "/customer-report-response/:id/print",
    meta: {
      auth: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "customer-report-response" */ "../views/CustomerReportResponse.vue"
      ),
  },
  {
    name: "customer-account",
    path: "/customer-account",
    meta: {
      auth: false,
    },
    component: () => import("../views/CustomerAccount.vue"),
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: {
      auth: false,
    },
    component: () => import("../views/account/PrivacyPolicy.vue"),
  },
];

const router = new VueRouter({
  routes,
  mode: "hash",
});

router.beforeEach((to, from, next) => {
  const needsEmployeeAuth = to.matched.some(
    (r) => r.meta.employeeAuth === true
  );
  const employeeGuest = to.matched.some((r) => r.meta.employeeGuest === true);

  if (needsEmployeeAuth && !isEmployeeSessionValid()) {
    next({ name: "employee-app-login", replace: true });
    return;
  }
  if (employeeGuest && isEmployeeSessionValid()) {
    next({ name: "employee-app-home", replace: true });
    return;
  }

  const navKey = to.name ? `navigation.${to.name}` : "navigation.home";
  const pageTitle = i18n.te(navKey) ? i18n.t(navKey) : Settings.projectName;
  document.title = `${pageTitle} | ${Settings.projectName}`;
  next();
});
export default router;
